import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../Homepage/TravelSolution/TravelSolution.css";

const PartnersContent = () => {
  return (
    <>
      <div className="container travel-solutions-section pt-xxl-5  mt-5 mb-5">
        <div className="row ps-2">
          <div className="row">
            <div className="col-md-8 mt-md-5 mt-3 paddingL">
              <h3 className="first-section headings">About Our Partnerships</h3>
              <div
                className="bgimage"
                style={{
                  "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                }}
              >
                <p className="mt-4 fs5">
                  Blueberry Travels thrives on collaboration, building
                  partnerships that deliver value and innovation. By combining
                  expertise and vision, we create impactful alliances that
                  redefine every clients’ travel experiences. Our commitment to
                  mutual growth ensures every partnership is a journey towards
                  success.
                </p>
              </div>
            </div>
            <div className="col-md-4 right-side  d-none d-md-block">
              <div className="d-flex justify-content-center mt-2">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/partners1.png"
                  alt=""
                  className=" mt-5 img-fluid"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-8 mt-md-5 mt-3 paddingL">
              <h3 className="second-section headings">Who We Work With</h3>
              <div
                className="bgimage"
                style={{
                  "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                }}
              >
                <p className="mt-4 fs5">
                  From industry leaders to niche innovators, we work with a
                  diverse range of partners, including airlines, hotels,
                  corporate clients, and tourism boards. Our major focus is on
                  creating personalized solutions that meet the distinct needs
                  of every collaborator, driving shared success and innovations
                  across industries.
                </p>
              </div>
            </div>
            <div className="col-md-4 right-side  d-none d-md-block">
              <div className="d-flex justify-content-center mt-2">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/partners2.png"
                  alt=""
                  className=" mt-5 img-fluid"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-8 mt-md-5 mt-3 paddingL">
              <h3 className="third-section headings">Why Partner With Us</h3>
              <div
                className="bgimage"
                style={{
                  "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/BLUEBERRY2.png"})`,
                }}
              >
                <p className="mt-4 fs5">
                  Partnering with Blueberry Travels means joining a network
                  dedicated to excellence and growth. With global resources,
                  innovative technology, and a personalized approach, we ensure
                  every collaboration delivers measurable, impactful, and
                  rewarding value. Partner with us to achieve growth and
                  remarkable results together.
                </p>
              </div>
            </div>
            <div className="col-md-4 right-side  d-none d-md-block">
              <div className="d-flex justify-content-center mt-2">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/partners3.png"
                  alt=""
                  className=" mt-5 img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PartnersContent;
